import * as React from 'react';

export function useWheelStopPropagation(ref: React.MutableRefObject<HTMLDivElement | null>) {
    React.useEffect(() => {
        ref.current!.addEventListener('wheel', stopPropagation, {
            passive: false,
        });
        return () => {
            ref.current!.removeEventListener('wheel', stopPropagation);
        };
    }, [ref.current]);
}

function stopPropagation(e: WheelEvent) {
    e.stopPropagation();
}
